import "../styles/contact.css";
import Alert from "./alert";

import { BiMailSend } from "react-icons/bi";
import { RiLinkedinBoxFill, RiWhatsappLine } from "react-icons/ri";
import { HiArrowNarrowRight } from "react-icons/hi";

import { useState } from "react";

let timeout;
export default function Contact() {
	const [name, setName] = useState("");
	const [email, setEmail] = useState("");
	const [message, setMessage] = useState("");
	const [sucess, setSucess] = useState(false);
	const [showAlert, setAlert] = useState(false);
	const [warningMessage, setWarning] = useState("");

	const [loader, setLoader] = useState(false);

	async function sendMessage(e) {
		clearTimeout(timeout);
		e.preventDefault();
		setLoader(true);
		if (name.length < 3) {
			displayAlert("Name Cannot be less than 3");
			setLoader(false);
			return 0;
		} else if (
			email.length < 3 ||
			!email.includes("@") ||
			!email.includes(".")
		) {
			displayAlert("Please enter a valid email");
			setLoader(false);
			return 0;
		} else if (message.length < 1) {
			displayAlert("Please enter a message");
			setLoader(false);
			return 0;
		}
		const requestOptions = {
			method: "POST",
			headers: {
				Accept: "application/json",
				"Content-Type": "application/json",
			},
			body: JSON.stringify({
				name: name,
				email: email,
				message: message,
			}),
		};
		fetch(
			"https://portfolio-website-server-one.herokuapp.com/api/logMessage",
			requestOptions
		)
			.then((response) => {
				console.log(response);
				setLoader(false);
				setSucess(true);
				setTimeout(() => {
					setSucess(false);
				}, 5000);
			})
			.catch((error) => {
				console.log("There was an error!", error);
				setLoader(false);
				displayAlert("Message not sent, Some error occured!");
			});
	}

	function displayAlert(msg) {
		setWarning(msg);
		setAlert(true);
		timeout = setTimeout(() => {
			setAlert(false);
		}, 5000);
	}
	function setAlertFalse() {
		setAlert(false);
	}
	function setSucessFalse() {
		setSucess(false);
	}

	return (
		<section className="contact section" id="contact">
			{showAlert && (
				<Alert
					message={warningMessage}
					Style="warning-alert"
					function={setAlertFalse}
				/>
			)}
			{sucess && (
				<Alert
					message="Recieved, Thank-you!"
					Style="success-alert"
					function={setSucessFalse}
				/>
			)}
			<span className="section__subtitle">Get in touch</span>
			<h2 className="section__title">Contact Me</h2>

			<div className="contact__container container grid">
				<div className="contact__content">
					<h3 className="contact__title">Talk to me</h3>

					<div className="contact__info">
						<div className="contact__card">
							<BiMailSend className="contact__card_icon" />
							<h3 className="contact__card_title">Email</h3>
							<span className="contact__card_data">
								mail@vaibhavaswal.codes
							</span>

							<a
								href="mailto:mail@vaibhavaswal.codes"
								target="_blank"
								rel="noreferrer"
								className="contact__button"
							>
								write me <HiArrowNarrowRight className="contact__button_icon" />
							</a>
						</div>

						<div className="contact__card">
							<RiLinkedinBoxFill className="contact__card_icon" />
							<h3 className="contact__card_title">Linkedin</h3>
							<span className="contact__card_data">@VaibhavAswal</span>

							<a
								href="https://in.linkedin.com/in/vaibhavaswal"
								target="_blank"
								rel="noreferrer"
								className="contact__button"
							>
								write me <HiArrowNarrowRight className="contact__button_icon" />
							</a>
						</div>

						<div className="contact__card">
							<RiWhatsappLine className="contact__card_icon" />
							<h3 className="contact__card_title">WhatsApp</h3>
							<span className="contact__card_data">+91 9760343766</span>

							<a
								href="https://wa.me/+919760343766"
								target="_blank"
								rel="noreferrer"
								className="contact__button"
							>
								write me <HiArrowNarrowRight className="contact__button_icon" />
							</a>
						</div>
					</div>
				</div>

				<div className="contact__content">
					<h3 className="contact__title">Write me your thaughts</h3>

					<form action="" method="get" className="contact__form">
						<div className="contact__form_div">
							<label htmlFor="" className="contact__form_tag">
								Name
							</label>
							<input
								type="text"
								name="name"
								id="name"
								placeholder="Insert your name"
								className="contact__form_input"
								onChange={(e) => setName(e.target.value)}
							/>
						</div>

						<div className="contact__form_div">
							<label htmlFor="" className="contact__form_tag">
								Mail
							</label>
							<input
								type="email"
								name="email"
								id="email"
								placeholder="Insert your email"
								className="contact__form_input"
								onChange={(e) => setEmail(e.target.value)}
							/>
						</div>

						<div className="contact__form_div contact__form_area">
							<label htmlFor="" className="contact__form_tag">
								Message
							</label>
							<textarea
								name="message"
								id="message"
								cols="30"
								rows="10"
								placeholder="Write your message"
								className="contact__form_input"
								onChange={(e) => setMessage(e.target.value)}
							></textarea>
						</div>
						<div
							className={`progress-btn ${loader && "active"}`}
							onClick={sendMessage}
							data-progress-style="indefinite"
						>
							<div className="contact_btn">Send</div>
							<div className="progress"></div>
						</div>
					</form>
				</div>
			</div>
		</section>
	);
}
